<template>
  <base-dialog width="485px" ref="dialog" class="setting-gateway-dialog" :visible.sync="visible">
    <template v-slot:header>
      设置筛选条件
    </template>
    <span style="color: #9e9e9e;">设置筛选条件后，满足条件的数据才能进入该分支</span>

    <condition-list
      v-loading="loading"
      ref="conditionList"
      :conditions="conditions"
      :workflow-var-list="flowConnectedData"
      from="workflow_gateway"
      @add-condition="scrollToBottom"
    ></condition-list>

    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">
        确定
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import ConditionList from "@/components/UIComponents/ConditionList/ConditionList"
import BaseDialog from "@/components/UIComponents/BaseDialog"
import BaseButton from "@/components/UIComponents/Button"
import Filters from "../mixin/filters"
import { EventBus } from "../eventBus"
import { verifyCondition } from "@/utils/sheet"
import { getWorkflowVars } from "@/api/workflow/workflow"
import { transOldExpr } from "@/utils/workFlow"

export default {
  name: "setting-gateway-dialog",
  components: { BaseDialog, ConditionList, BaseButton },
  props: {
    workFlowId: String
  },
  mixins: [Filters],
  data() {
    return {
      visible: false,
      loading: true,
      flowConnectedData: [],
      conditions: [],
      gateway: null,
      branchIndex: -1
    }
  },
  methods: {
    open(eventParam) {
      this.gateway = eventParam.workFlow
      this.branchIndex = eventParam.branchIndex
      this.visible = true
      this.loading = true
      this.conditions = []
      getWorkflowVars(this.workFlowId, this.gateway.id).then(flowConnectedData => {
        this.flowConnectedData = flowConnectedData
        this.conditions = this.transOldExpr(
          this._.cloneDeep(this.gateway.data.nextFilters?.[this.branchIndex]) || []
        )
        this.loading = false
        this.scrollToBottom()
      })
    },
    transOldExpr(conditions) {
      this._.flatten(conditions).forEach(condition => {
        Object.assign(condition, {
          key: transOldExpr(condition.key),
          varItems: condition.varItems.map(varItem => ({
            var: varItem.var,
            value: varItem.var ? transOldExpr(varItem.value) : varItem.value
          }))
        })
      })
      return conditions
    },
    submit() {
      let { result, msg } = verifyCondition("submit", this.conditions)
      if (!result) {
        this.$message.error(msg)
        return
      }
      this.gateway.data.nextFilters[this.branchIndex] = this.conditions
      this.gateway.extra = this.gateway.extra || {}
      let description = this.gateway.extra.description || []
      description[this.branchIndex] = this.$refs.conditionList.getConditionDescription()
      this.gateway.extra.description = description
      EventBus.$emit("updateFlowNode", {
        nodeInfo: this.gateway
      })
      this.visible = false
    },
    scrollToBottom() {
      this.$nextTick(() => this.$refs.dialog.scrollToBottom())
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-gateway-dialog {
}
</style>
